<template>
    <transition name="supsis-archive-modal-fade">
        <div class="supsis-archive-modal-overlay-v2xuniq" @click="handleOverlayClick">
            <div class="supsis-archive-modal-container-v2xuniq" @click.stop>
                <div class="supsis-archive-modal-header-v2xuniq">
                    <div class="supsis-archive-header-content-v2xuniq">
                        <span class="material-icons supsis-archive-header-icon-v2xuniq">{{ activeTab === 'archive' ? 'archive' : 'delete' }}</span>
                        <h2 class="supsis-archive-header-title-v2xuniq">{{ $t('task.archiveAndTrash') }}</h2>
                    </div>
                    <button class="supsis-archive-close-btn-v2xuniq" @click="handleClose">
                        <span class="material-icons">close</span>
                    </button>
                </div>

                <div class="supsis-archive-modal-body-v2xuniq">
                    <div class="supsis-archive-control-bar-v2xuniq">
                        <div class="supsis-archive-tab-switcher-v2xuniq">
                            <button
                                :class="['supsis-archive-tab-btn-v2xuniq', { active: activeTab === 'archive' }]"
                                @click="switchTab('archive')"
                            >
                                <span class="material-icons">inventory_2</span>
                                <span class="supsis-archive-tab-text-v2xuniq">{{ $t('message.archive') }}</span>
                                <span v-if="activeTab === 'archive' && totalTasks" class="supsis-archive-count-badge-v2xuniq">{{ totalTasks }}</span>
                            </button>
                            <button
                                :class="['supsis-archive-tab-btn-v2xuniq', { active: activeTab === 'trash' }]"
                                @click="switchTab('trash')"
                            >
                                <span class="material-icons">delete_outline</span>
                                <span class="supsis-archive-tab-text-v2xuniq">{{ $t('task.trash') }}</span>
                                <span v-if="activeTab === 'trash' && totalTasks" class="supsis-archive-count-badge-v2xuniq">{{ totalTasks }}</span>
                            </button>
                        </div>

                        <div class="supsis-archive-action-bar-v2xuniq">
                            <div class="supsis-archive-date-filter-v2xuniq">
                                <span class="material-icons supsis-archive-filter-icon-v2xuniq">event</span>
                                <span class="supsis-archive-filter-label-v2xuniq">{{ activeTab === 'archive' ? 'Arşivlenme Tarihi:' : 'Silinme Tarihi:' }}</span>
                                <a-range-picker
                                    v-model="dateRange"
                                    :placeholder="['Başlangıç', 'Bitiş']"
                                    format="DD/MM/YYYY"
                                    @change="handleDateChangeDebounced"
                                    class="supsis-archive-date-range-input-v2xuniq"
                                />
                                <transition name="supsis-archive-fade-scale">
                                    <button v-if="dateRange && dateRange.length" @click="clearDateFilter" class="supsis-archive-filter-clear-v2xuniq">
                                        <span class="material-icons">close</span>
                                    </button>
                                </transition>
                            </div>

                            <div class="supsis-archive-view-switcher-v2xuniq">
                                <button
                                    :class="['supsis-archive-view-btn-v2xuniq', { active: viewMode === 'grid' }]"
                                    @click="viewMode = 'grid'"
                                    v-tippy="{ content: 'Izgara Görünümü' }"
                                >
                                    <span class="material-icons">apps</span>
                                </button>
                                <button
                                    :class="['supsis-archive-view-btn-v2xuniq', { active: viewMode === 'list' }]"
                                    @click="viewMode = 'list'"
                                    v-tippy="{ content: 'Liste Görünümü' }"
                                >
                                    <span class="material-icons">view_agenda</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <transition name="supsis-archive-fade" mode="out-in">
                        <div v-if="loading" key="loading" class="supsis-archive-content-loader-v2xuniq">
                            <a-spin size="large" />
                            <p class="supsis-archive-loading-text-v2xuniq">{{ $t('task.loading') }}</p>
                        </div>

                        <div v-else-if="tasks && tasks.length > 0" key="content" class="supsis-archive-content-area-v2xuniq">
                            <div :class="viewMode === 'grid' ? 'supsis-archive-tasks-grid-v2xuniq' : 'supsis-archive-tasks-list-v2xuniq'">
                                <div
                                    v-for="task in tasks"
                                    :key="task._id"
                                    :class="viewMode === 'grid' ? 'supsis-archive-task-grid-card-v2xuniq' : 'supsis-archive-task-list-card-v2xuniq'"
                                    @click="edit(task)"
                                >
                                    <div v-if="viewMode === 'grid'" class="supsis-archive-grid-card-inner-v2xuniq">
                                        <div v-if="task.attachments && task.attachments.length > 0" class="supsis-archive-card-image-v2xuniq">
                                            <img :src="getAttachmentUrl(task.attachments[0])" :alt="task.title" />
                                        </div>
                                        <div v-else class="supsis-archive-card-image-v2xuniq supsis-archive-card-image-placeholder-v2xuniq">
                                            <span class="material-icons supsis-archive-placeholder-icon-v2xuniq">task_alt</span>
                                        </div>

                                        <div class="supsis-archive-card-body-v2xuniq">
                                            <div class="supsis-archive-card-header-v2xuniq">
                                                <h3 class="supsis-archive-card-title-v2xuniq">{{ task.title }}</h3>
                                                <div @click.stop>
                                                    <a-dropdown :trigger="['click']">
                                                        <button class="supsis-archive-card-menu-btn-v2xuniq">
                                                            <span class="material-icons">more_vert</span>
                                                        </button>
                                                        <template #overlay>
                                                            <a-menu class="supsis-archive-task-actions-menu-v2xuniq">
                                                                <a-menu-item v-for="action of filteredActions" :key="action.action" @click="runAction(action.action, task)">
                                                                    <span class="material-icons">{{ action.icon }}</span>
                                                                    {{ action.text }}
                                                                </a-menu-item>
                                                            </a-menu>
                                                        </template>
                                                    </a-dropdown>
                                                </div>

                                            </div>

                                            <div v-if="task.tags && task.tags.length > 0" class="supsis-archive-card-tags-v2xuniq">
                                                <span
                                                    v-for="tag in task.tags.slice(0, 2)"
                                                    :key="tag._id"
                                                    :style="getTagStyle(tag.color)"
                                                    class="supsis-archive-tag-chip-v2xuniq"
                                                >
                                                    {{ tag.name }}
                                                </span>
                                                <span v-if="task.tags.length > 2" class="supsis-archive-tag-more-v2xuniq">+{{ task.tags.length - 2 }}</span>
                                            </div>

                                            <div class="supsis-archive-card-footer-v2xuniq">
                                                <div class="supsis-archive-card-priority-v2xuniq">
                                                    <component :is="getPriorityIcon(task.priority)" />
                                                </div>
                                                <div class="supsis-archive-card-assignees-v2xuniq">
                                                    <Avatar
                                                        v-for="userId in getAssigneesUserId(task).slice(0, 2)"
                                                        :key="userId"
                                                        :size="24"
                                                        :src="users[userId] && users[userId].gravatar"
                                                        :username="users[userId] && users[userId].name"
                                                        v-tippy="{
                                                            content: users[userId] && users[userId].email,
                                                            placement: 'top',
                                                        }"
                                                    />
                                                    <span v-if="getAssigneesUserId(task).length > 2" class="supsis-archive-avatar-more-v2xuniq">
                                                        +{{ getAssigneesUserId(task).length - 2 }}
                                                    </span>
                                                </div>

                                                <div class="supsis-archive-card-stats-v2xuniq">
                                                    <span v-if="task.checklist && task.checklist.length > 0" class="supsis-archive-stat-badge-v2xuniq">
                                                        <span class="material-icons">checklist</span>
                                                        {{ getCompletedChecklistCount(task) }}/{{ task.checklist.length }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else class="supsis-archive-list-card-inner-v2xuniq">
                                        <div v-if="task.attachments && task.attachments.length > 0" class="supsis-archive-list-thumbnail-v2xuniq">
                                            <img :src="getAttachmentUrl(task.attachments[0])" :alt="task.title" />
                                        </div>

                                        <div class="supsis-archive-list-content-v2xuniq">
                                            <div class="supsis-archive-list-header-v2xuniq">
                                                <h3 class="supsis-archive-list-title-v2xuniq">{{ task.title }}</h3>
                                                <component :is="getPriorityIcon(task.priority)" class="supsis-archive-priority-icon-v2xuniq" />
                                            </div>

                                            <p v-if="task.description" class="supsis-archive-list-description-v2xuniq">
                                                {{ truncateText(task.description, 100) }}
                                            </p>

                                            <div v-if="task.tags && task.tags.length > 0" class="supsis-archive-list-tags-v2xuniq">
                                                <span
                                                    v-for="tag in task.tags.slice(0, 3)"
                                                    :key="tag._id"
                                                    :style="getTagStyle(tag.color)"
                                                    class="supsis-archive-list-tag-v2xuniq"
                                                >
                                                    {{ tag.name }}
                                                </span>
                                                <span v-if="task.tags.length > 3" class="supsis-archive-tag-more-v2xuniq">+{{ task.tags.length - 3 }}</span>
                                            </div>

                                            <div class="supsis-archive-list-footer-v2xuniq">
                                                <div class="supsis-archive-list-assignees-v2xuniq">
                                                    <Avatar
                                                        v-for="userId in getAssigneesUserId(task).slice(0, 3)"
                                                        :key="userId"
                                                        :size="24"
                                                        :src="users[userId] && users[userId].gravatar"
                                                        :username="users[userId] && users[userId].name"
                                                        v-tippy="{
                                                            content: users[userId] && users[userId].email,
                                                            placement: 'top',
                                                        }"
                                                    />
                                                    <span v-if="getAssigneesUserId(task).length > 3" class="supsis-archive-avatar-more-v2xuniq">
                                                        +{{ getAssigneesUserId(task).length - 3 }}
                                                    </span>
                                                </div>

                                                <div class="supsis-archive-list-meta-v2xuniq">
                                                    <span v-if="task.checklist && task.checklist.length > 0" class="supsis-archive-meta-badge-v2xuniq">
                                                        <span class="material-icons">checklist</span>
                                                        {{ getCompletedChecklistCount(task) }}/{{ task.checklist.length }}
                                                    </span>
                                                    <span v-if="(task.subTasks || []).length > 0" class="supsis-archive-meta-badge-v2xuniq">
                                                        <span class="material-icons">account_tree</span>
                                                        {{ getCompletedParentTaskCount(task) }}/{{ task.subTasks.length }}
                                                    </span>
                                                </div>

                                                <a-dropdown :trigger="['click']" @click.stop>
                                                    <button class="supsis-archive-list-menu-btn-v2xuniq">
                                                        <span class="material-icons">more_vert</span>
                                                    </button>
                                                    <template #overlay>
                                                        <a-menu class="supsis-archive-task-actions-menu-v2xuniq">
                                                            <a-menu-item v-for="action of filteredActions" :key="action.action" @click="runAction(action.action, task)">
                                                                <span class="material-icons">{{ action.icon }}</span>
                                                                {{ action.text }}
                                                            </a-menu-item>
                                                        </a-menu>
                                                    </template>
                                                </a-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else key="empty" class="supsis-archive-empty-state-v2xuniq">
                            <div class="supsis-archive-empty-illustration-v2xuniq">
                                <span class="material-icons supsis-archive-empty-icon-v2xuniq">
                                    {{ activeTab === 'archive' ? 'inventory_2' : 'delete_outline' }}
                                </span>
                            </div>
                            <h3 class="supsis-archive-empty-title-v2xuniq">
                                {{ activeTab === 'archive' ? $t('task.noArchivedTasks') : $t('task.noDeletedTasks') }}
                            </h3>
                            <p class="supsis-archive-empty-description-v2xuniq">
                                {{ activeTab === 'archive' ? 'Arşivlenmiş görev bulunmamaktadır.' : 'Silinmiş görev bulunmamaktadır.' }}
                            </p>
                        </div>
                    </transition>
                </div>

                <transition name="supsis-archive-slide-up">
                    <div v-if="!loading && tasks && tasks.length > 0" class="supsis-archive-modal-footer-v2xuniq">
                        <div class="supsis-archive-footer-info-v2xuniq">
                            <span class="material-icons">info</span>
                            Toplam <strong>{{ totalTasks }}</strong> görev
                        </div>
                        <a-pagination
                            v-model="currentPage"
                            :total="totalTasks"
                            :pageSize="perPage"
                            :showTotal="(total, range) => `${range[0]}-${range[1]}`"
                            @change="handlePageChange"
                            :showSizeChanger="false"
                            class="supsis-archive-custom-pagination-v2xuniq"
                        />
                    </div>
                </transition>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import _ from "lodash";
import LowIcon from "../../svg/task/LowIcon.vue";
import LowestIcon from "../../svg/task/LowestIcon.vue";
import MediumIcon from "../../svg/task/MediumIcon.vue";
import HighIcon from "../../svg/task/HighIcon.vue";
import HighestIcon from "../../svg/task/HighestIcon.vue";
import Avatar from "vue-avatar";
import { publishMessage, SystemMessageTypes } from "../../../utils/systemPubSub";

export default {
    name: "TaskArchiveModal",
    props: {
        workflow: String,
    },
    components: {
        Avatar,
        LowIcon,
        LowestIcon,
        MediumIcon,
        HighIcon,
        HighestIcon,
    },
    data() {
        return {
            tasks: null,
            activeTab: 'archive',
            viewMode: localStorage.getItem('taskArchiveViewMode') || 'grid',
            loading: false,
            currentPage: 1,
            perPage: 20,
            totalTasks: 0,
            dateRange: null,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        filteredActions() {
            return this.actions;
        },
        actions() {
            const actions = [
                {
                    icon: "edit",
                    text: this.$t("settings.edit"),
                    action: "edit",
                },
                {
                    icon: this.activeTab === 'trash' ? "restore" : "delete",
                    text: this.activeTab === 'trash' ? this.$t('task.moveToBoard') : this.$t("chatbotv2.delete"),
                    action: "deleteTaskModalOpen",
                },
            ];

            if (this.activeTab === 'archive') {
                actions.push({
                    icon: "unarchive",
                    text: this.$t('task.unarchive'),
                    action: "archived",
                });
            }

            return actions;
        },
    },
    watch: {
        viewMode(newValue) {
            localStorage.setItem('taskArchiveViewMode', newValue);
        }
    },
    methods: {
        ...mapActions({
            getArchiveTasks: "tasks/getArchiveTasks",
            getDeleteTask: "tasks/getDeleteTask",
            addNewWindow: "app/addNewWindow",
            deleteTask: "tasks/deleteTask",
            toggleArchiveTask: "tasks/toggleArchiveTask",
        }),
        handleClose() {
            this.$emit('close');
        },
        handleOverlayClick() {
            this.handleClose();
        },
        fetchTasks() {
            this.loading = true;
            const params = {
                workflowId: this.workflow,
                page: this.currentPage,
                perPage: this.perPage,
            };

            const fetchMethod = this.activeTab === 'archive' ? 'getArchiveTasks' : 'getDeleteTask';
            const dateParam = this.activeTab === 'archive' ? 'archivedDateRange' : 'deletedDateRange';

            if (this.dateRange && this.dateRange.length === 2) {
                params[dateParam] = [
                    moment(this.dateRange[0]).startOf('day').toISOString(),
                    moment(this.dateRange[1]).endOf('day').toISOString()
                ];
            }

            this[fetchMethod](params)
                .then((response) => {
                    this.tasks = (response.data || response);
                    this.totalTasks = response.total || this.tasks.length;
                })
                .catch((error) => {
                    console.error(`Error fetching ${this.activeTab} tasks:`, error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleDateChangeDebounced: _.debounce(function() {
            this.currentPage = 1;
            this.fetchTasks();
        }, 500),
        switchTab(tab) {
            if (this.activeTab === tab) return;
            this.activeTab = tab;
            this.currentPage = 1;
            this.dateRange = null;
            this.tasks = null;
            this.fetchTasks();
        },
        handlePageChange(page) {
            this.currentPage = page;
            this.fetchTasks();
        },
        clearDateFilter() {
            this.dateRange = null;
            this.currentPage = 1;
            this.fetchTasks();
        },
        getAttachmentUrl(attachment) {
            if (attachment.v2Format && attachment.cdnUrl) {
                return attachment.cdnUrl;
            }
            return `https://static.supsis.live/${attachment.path}${attachment._id}.${attachment.ext}`;
        },
        getAssigneesUserId(item) {
            return _.uniq([item.assignees].flat()).filter((c) => this.users[c]);
        },
        getCompletedParentTaskCount(item) {
            return (item.subTasks || []).filter((item) => item.completed).length;
        },
        getCompletedChecklistCount(item) {
            return (item.checklist || []).filter((item) => item.isCompleted).length;
        },
        truncateText(text, length) {
            if (!text) return '';
            return text.length > length ? text.substring(0, length) + '...' : text;
        },
        edit(task) {
            const workflow = this.workflows[this.workflow];
            if (!workflow) return;

            const permissions = ["createTask", "editTask", "draggingTask", "deleteTask"].map(
                (permission) => workflow.permissions[permission]
            );
            const perm = permissions.every((permission) => permission.length === 0);
            if (perm || permissions[1].includes(this.user._id)) {
                this.addNewWindow({
                    type: "editor-task",
                    title: task.title,
                    payload: {
                        taskId: task._id,
                    },
                });
            } else {
                this.addNewWindow({
                    type: "preview-task",
                    title: task.title,
                    payload: {
                        taskId: task._id,
                    },
                    footer: false,
                });
            }
        },
        deleteTaskModalOpen(task) {
            if (this.activeTab === 'trash') {
                this.deleteTask(task)
                    .then((resTask) => {
                        publishMessage(SystemMessageTypes.TASK_MOVED_BOARD, {
                            task: resTask,
                            workflowId: this.workflow,
                        });
                        this.$notification.success({
                            message: this.$t('task.success'),
                            description: this.$t('task.taskMovedToBoard'),
                        });
                        this.fetchTasks();
                    })
                    .catch(() => {
                        this.$notification.error({
                            message: this.$t('task.error'),
                            description: this.$t('task.taskMoveError'),
                        });
                    });
            } else {
                this.deleteTask(task)
                    .then(() => {
                        this.$notification.success({
                            message: this.$t('task.success'),
                            description: this.$t('task.taskDeleted'),
                        });
                        this.fetchTasks();
                    })
                    .catch(() => {
                        this.$notification.error({
                            message: this.$t('task.error'),
                            description: this.$t('task.taskDeleteError'),
                        });
                    });
            }
        },
        archived(task) {
            this.toggleArchiveTask({
                taskId: task._id,
                workflowId: this.workflow,
                isArchived: false,
            })
                .then((archivedTask) => {
                    publishMessage(SystemMessageTypes.TASK_UNARCHIVED, {
                        archivedTask,
                        workflowId: this.workflow,
                    });
                    this.$notification.success({
                        message: this.$t('task.success'),
                        description: this.$t('task.taskUnarchived'),
                    });
                    this.fetchTasks();
                })
                .catch(() => {
                    this.$notification.error({
                        message: this.$t('task.error'),
                        description: this.$t('task.taskUnarchiveError'),
                    });
                });
        },
        runAction(fnName, task) {
            if (fnName === "archived") {
                this[fnName](task);
                return;
            }
            this[fnName](task);
        },
        getTagStyle(color) {
            return {
                backgroundColor: this.lightenColor(color, 0.5),
                color: color,
            };
        },
        lightenColor(color, percent) {
            if (!color) {
                return "#ffffff";
            }
            const num = parseInt(color.replace("#", ""), 16),
                amt = Math.round(2.55 * percent * 100),
                R = (num >> 16) + amt,
                G = ((num >> 8) & 0x00ff) + amt,
                B = (num & 0x0000ff) + amt;
            return (
                "#" +
                (
                    0x1000000 +
                    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
                    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
                    (B < 255 ? (B < 1 ? 0 : B) : 255)
                )
                    .toString(16)
                    .slice(1)
            );
        },
        getPriorityIcon(priority) {
            switch (priority) {
                case "low":
                    return LowIcon;
                case "lowest":
                    return LowestIcon;
                case "medium":
                    return MediumIcon;
                case "high":
                    return HighIcon;
                case "highest":
                    return HighestIcon;
                default:
                    return LowIcon;
            }
        },
    },
    created() {
        this.fetchTasks();
        document.body.style.overflow = 'hidden';
    },
    beforeDestroy() {
        if (this.handleDateChangeDebounced) {
            this.handleDateChangeDebounced.cancel();
        }
        document.body.style.overflow = '';
    },
};
</script>

<style lang="scss" scoped>
.supsis-archive-modal-overlay-v2xuniq {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    padding: 20px;
}

.supsis-archive-modal-container-v2xuniq {
    background: #fafafa;
    border-radius: 16px;
    width: 60vw;
    min-width: 900px;
    max-width: 1400px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    overflow: hidden;
}

.supsis-archive-modal-header-v2xuniq {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: white;
    border-bottom: 1px solid #f0f0f0;
}

.supsis-archive-header-content-v2xuniq {
    display: flex;
    align-items: center;
    gap: 12px;
}

.supsis-archive-header-icon-v2xuniq {
    font-size: 24px;
    color: #1890ff;
}

.supsis-archive-header-title-v2xuniq {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    color: #262626;
}

.supsis-archive-close-btn-v2xuniq {
    width: 36px;
    height: 36px;
    border: none;
    background: transparent;
    border-radius: 8px;
    color: #8c8c8c;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #f5f5f5;
        color: #262626;
        transform: scale(1.05);
    }

    .material-icons {
        font-size: 20px;
    }
}

.supsis-archive-modal-body-v2xuniq {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 20px 24px;
}

.supsis-archive-control-bar-v2xuniq {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 16px;
}

.supsis-archive-tab-switcher-v2xuniq {
    display: flex;
    gap: 8px;
}

.supsis-archive-tab-btn-v2xuniq {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 18px;
    border: 1px solid #e8e8e8;
    background: white;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    font-size: 14px;
    color: #595959;

    .material-icons {
        font-size: 18px;
    }

    .supsis-archive-count-badge-v2xuniq {
        background: #f5f5f5;
        color: #595959;
        padding: 3px 8px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 600;
        min-width: 22px;
        text-align: center;
    }

    &:hover {
        color: #1890ff;
        border-color: #91d5ff;
        background: #f0f9ff;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.08);

        .supsis-archive-count-badge-v2xuniq {
            background: #e6f7ff;
            color: #1890ff;
        }
    }

    &.active {
        background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
        border-color: #1890ff;
        color: white;
        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);

        .supsis-archive-count-badge-v2xuniq {
            background: rgba(255, 255, 255, 0.25);
            color: white;
        }
    }
}

.supsis-archive-action-bar-v2xuniq {
    display: flex;
    gap: 12px;
    align-items: center;
}

.supsis-archive-date-filter-v2xuniq {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    background: white;
    padding: 10px 18px;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    transition: all 0.3s ease;

    &:hover {
        border-color: #91d5ff;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.06);
    }
}

.supsis-archive-filter-icon-v2xuniq {
    color: #1890ff;
    font-size: 20px;
}

.supsis-archive-filter-label-v2xuniq {
    font-size: 14px;
    font-weight: 500;
    color: #262626;
    white-space: nowrap;
}

.supsis-archive-date-range-input-v2xuniq {
    flex: 1;
}

.supsis-archive-filter-clear-v2xuniq {
    width: 26px;
    height: 26px;
    border: none;
    background: #ff4d4f;
    color: white;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    &:hover {
        background: #ff7875;
        transform: scale(1.1);
        box-shadow: 0 2px 8px rgba(255, 77, 79, 0.3);
    }

    .material-icons {
        font-size: 16px;
    }
}

.supsis-archive-view-switcher-v2xuniq {
    display: flex;
    gap: 4px;
}

.supsis-archive-view-btn-v2xuniq {
    width: 36px;
    height: 36px;
    border: 1px solid #e8e8e8;
    background: white;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #595959;
    display: flex;
    align-items: center;
    justify-content: center;

    .material-icons {
        font-size: 18px;
    }

    &:hover {
        color: #1890ff;
        border-color: #91d5ff;
        background: #f0f9ff;
        transform: scale(1.05);
    }

    &.active {
        background: #1890ff;
        border-color: #1890ff;
        color: white;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
    }
}

.supsis-archive-content-loader-v2xuniq {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.supsis-archive-loading-text-v2xuniq {
    color: #8c8c8c;
    font-size: 14px;
    margin: 0;
}

.supsis-archive-content-area-v2xuniq {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f0f0f0;
    }

    &::-webkit-scrollbar-thumb {
        background: #d9d9d9;
        border-radius: 3px;

        &:hover {
            background: #bfbfbf;
        }
    }
}

.supsis-archive-tasks-grid-v2xuniq {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
    padding: 0;
}

.supsis-archive-task-grid-card-v2xuniq {
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-4px);
        z-index: 10;
    }
}

.supsis-archive-grid-card-inner-v2xuniq {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #f0f0f0;
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    &:hover {
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
        border-color: #91d5ff;
        transform: translateY(-2px);
    }
}

.supsis-archive-card-image-v2xuniq {
    width: 100%;
    height: 0;
    padding-bottom: 60%;
    position: relative;
    overflow: hidden;
    background: #f5f5f5;

    img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &.supsis-archive-card-image-placeholder-v2xuniq {
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);

        .supsis-archive-placeholder-icon-v2xuniq {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 48px;
            color: #bfbfbf;
        }
    }
}

.supsis-archive-card-body-v2xuniq {
    padding: 16px;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.supsis-archive-card-header-v2xuniq {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
}

.supsis-archive-card-title-v2xuniq {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    flex: 1;
    color: #262626;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.supsis-archive-card-menu-btn-v2xuniq {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    color: #8c8c8c;
    padding: 0;

    &:hover {
        background: #f5f5f5;
        color: #262626;
        transform: scale(1.1);
    }

    .material-icons {
        font-size: 18px;
    }
}

.supsis-archive-card-tags-v2xuniq {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    min-height: 24px;
}

.supsis-archive-tag-chip-v2xuniq {
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
}

.supsis-archive-tag-more-v2xuniq {
    padding: 3px 8px;
    background: #f5f5f5;
    color: #8c8c8c;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 600;
}

.supsis-archive-card-footer-v2xuniq {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-top: auto;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;
}

.supsis-archive-card-priority-v2xuniq {
    svg {
        width: 18px;
        height: 18px;
    }
}

.supsis-archive-card-assignees-v2xuniq {
    display: flex;
    align-items: center;
    gap: 2px;

    .vue-avatar {
        margin-right: -8px;
        border: 2px solid white;
    }
}

.supsis-archive-avatar-more-v2xuniq {
    width: 22px;
    height: 22px;
    background: #1890ff;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 700;
    margin-left: 6px;
    border: 2px solid white;
}

.supsis-archive-card-stats-v2xuniq {
    display: flex;
    gap: 6px;
}

.supsis-archive-stat-badge-v2xuniq {
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: 11px;
    font-weight: 500;
    color: #8c8c8c;

    .material-icons {
        font-size: 15px;
    }
}

.supsis-archive-tasks-list-v2xuniq {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.supsis-archive-task-list-card-v2xuniq {
    cursor: pointer;
}

.supsis-archive-list-card-inner-v2xuniq {
    background: white;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    gap: 14px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #f0f0f0;

    &:hover {
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
        border-color: #91d5ff;
        transform: translateY(-1px);
    }
}

.supsis-archive-list-thumbnail-v2xuniq {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    border-radius: 8px;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.supsis-archive-list-content-v2xuniq {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.supsis-archive-list-header-v2xuniq {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
}

.supsis-archive-list-title-v2xuniq {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    color: #262626;
    flex: 1;
}

.supsis-archive-priority-icon-v2xuniq {
    flex-shrink: 0;

    svg {
        width: 18px;
        height: 18px;
    }
}

.supsis-archive-list-description-v2xuniq {
    font-size: 12px;
    color: #8c8c8c;
    line-height: 1.5;
    margin: 0;
}

.supsis-archive-list-tags-v2xuniq {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.supsis-archive-list-tag-v2xuniq {
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 500;
}

.supsis-archive-list-footer-v2xuniq {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.supsis-archive-list-assignees-v2xuniq {
    display: flex;
    align-items: center;
    gap: 2px;

    .vue-avatar {
        margin-right: -6px;
        border: 2px solid white;
    }
}

.supsis-archive-list-meta-v2xuniq {
    display: flex;
    gap: 8px;
}

.supsis-archive-meta-badge-v2xuniq {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 500;
    color: #8c8c8c;

    .material-icons {
        font-size: 14px;
    }
}

.supsis-archive-list-menu-btn-v2xuniq {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    color: #8c8c8c;
    padding: 0;

    &:hover {
        background: #f5f5f5;
        color: #262626;
    }

    .material-icons {
        font-size: 18px;
    }
}

.supsis-archive-empty-state-v2xuniq {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    min-height: 300px;
}

.supsis-archive-empty-illustration-v2xuniq {
    width: 120px;
    height: 120px;
    margin-bottom: 24px;
    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.supsis-archive-empty-icon-v2xuniq {
    font-size: 56px;
    color: #bfbfbf;
}

.supsis-archive-empty-title-v2xuniq {
    font-size: 18px;
    font-weight: 600;
    color: #262626;
    margin: 0 0 8px 0;
    text-align: center;
}

.supsis-archive-empty-description-v2xuniq {
    font-size: 14px;
    color: #8c8c8c;
    margin: 0;
    text-align: center;
    max-width: 400px;
}

.supsis-archive-modal-footer-v2xuniq {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: white;
    border-top: 1px solid #f0f0f0;
}

.supsis-archive-footer-info-v2xuniq {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #595959;

    .material-icons {
        font-size: 16px;
        color: #1890ff;
    }

    strong {
        color: #262626;
        font-weight: 600;
    }
}

.supsis-archive-task-actions-menu-v2xuniq {
    .ant-menu-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        font-size: 13px;

        .material-icons {
            font-size: 16px;
            color: #8c8c8c;
        }

        &:hover {
            background: #f5f5f5;

            .material-icons {
                color: #1890ff;
            }
        }
    }
}

.supsis-archive-modal-fade-enter-active,
.supsis-archive-modal-fade-leave-active {
    transition: all 0.3s ease;
}

.supsis-archive-modal-fade-enter,
.supsis-archive-modal-fade-leave-to {
    opacity: 0;
}

.supsis-archive-modal-fade-enter .supsis-archive-modal-container-v2xuniq,
.supsis-archive-modal-fade-leave-to .supsis-archive-modal-container-v2xuniq {
    transform: scale(0.95);
    opacity: 0;
}

.supsis-archive-fade-scale-enter-active,
.supsis-archive-fade-scale-leave-active {
    transition: all 0.2s ease;
}

.supsis-archive-fade-scale-enter,
.supsis-archive-fade-scale-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.supsis-archive-slide-up-enter-active,
.supsis-archive-slide-up-leave-active {
    transition: all 0.3s ease;
}

.supsis-archive-slide-up-enter,
.supsis-archive-slide-up-leave-to {
    opacity: 0;
    transform: translateY(10px);
}

.supsis-archive-fade-enter-active,
.supsis-archive-fade-leave-active {
    transition: opacity 0.3s ease;
}

.supsis-archive-fade-enter,
.supsis-archive-fade-leave-to {
    opacity: 0;
}

@media (max-width: 1400px) {
    .supsis-archive-modal-container-v2xuniq {
        width: 75vw;
        min-width: 800px;
    }

    .supsis-archive-tasks-grid-v2xuniq {
        grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
        gap: 18px;
    }
}

@media (max-width: 1024px) {
    .supsis-archive-modal-container-v2xuniq {
        width: 85vw;
        min-width: 700px;
    }

    .supsis-archive-tasks-grid-v2xuniq {
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
        gap: 16px;
    }
}

@media (max-width: 768px) {
    .supsis-archive-modal-container-v2xuniq {
        width: 95vw;
        min-width: unset;
        max-height: 95vh;
    }

    .supsis-archive-control-bar-v2xuniq {
        gap: 8px;
    }

    .supsis-archive-action-bar-v2xuniq {
        flex-direction: column;
        align-items: stretch;
    }

    .supsis-archive-date-filter-v2xuniq {
        width: 100%;
    }

    .supsis-archive-tasks-grid-v2xuniq {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 12px;
    }

    .supsis-archive-list-card-inner-v2xuniq {
        flex-direction: column;
    }

    .supsis-archive-list-thumbnail-v2xuniq {
        width: 100%;
        height: 120px;
    }

    .supsis-archive-modal-footer-v2xuniq {
        flex-direction: column;
        gap: 12px;
        align-items: center;
    }
}

@media (max-width: 480px) {
    .supsis-archive-tab-btn-v2xuniq {
        padding: 6px 12px;
        font-size: 12px;

        .material-icons {
            font-size: 16px;
        }

        .supsis-archive-tab-text-v2xuniq {
            display: none;
        }
    }

    .supsis-archive-filter-label-v2xuniq {
        display: none;
    }

    .supsis-archive-tasks-grid-v2xuniq {
        grid-template-columns: 1fr;
    }
}
</style>
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    padding: 20px;
}

.custom-modal-container {
    background: #fafafa;
    border-radius: 8px;
    width: 60vw;
    min-width: 900px;
    max-width: 1400px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    overflow: hidden;
}

.custom-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: white;
    border-bottom: 1px solid #e8e8e8;
}

.header-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-icon {
    font-size: 24px;
    color: #1890ff;
}

.header-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    color: #262626;
}

.close-btn {
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: 4px;
    color: #8c8c8c;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #f5f5f5;
        color: #262626;
    }

    .material-icons {
        font-size: 20px;
    }
}

.custom-modal-body {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 16px 20px;
}

.control-bar {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 16px;
}

.tab-switcher {
    display: flex;
    gap: 8px;
}

.tab-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px 16px;
    border: 1px solid #d9d9d9;
    background: white;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    font-size: 14px;
    color: #595959;

    .material-icons {
        font-size: 18px;
    }

    .count-badge {
        background: #f0f0f0;
        color: #595959;
        padding: 2px 6px;
        border-radius: 10px;
        font-size: 11px;
        font-weight: 600;
        min-width: 20px;
        text-align: center;
    }

    &:hover {
        color: #1890ff;
        border-color: #1890ff;

        .count-badge {
            background: #e6f7ff;
            color: #1890ff;
        }
    }

    &.active {
        background: #1890ff;
        border-color: #1890ff;
        color: white;

        .count-badge {
            background: rgba(255, 255, 255, 0.3);
            color: white;
        }
    }
}

.action-bar {
    display: flex;
    gap: 12px;
    align-items: center;
}

.date-filter {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    background: white;
    padding: 8px 16px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
}

.filter-icon {
    color: #1890ff;
    font-size: 20px;
}

.filter-label {
    font-size: 14px;
    font-weight: 500;
    color: #262626;
    white-space: nowrap;
}

.date-range-input {
    flex: 1;
}

.filter-clear {
    width: 24px;
    height: 24px;
    border: none;
    background: #ff4d4f;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    &:hover {
        background: #ff7875;
    }

    .material-icons {
        font-size: 16px;
    }
}

.view-switcher {
    display: flex;
    gap: 4px;
}

.view-btn {
    width: 32px;
    height: 32px;
    border: 1px solid #d9d9d9;
    background: white;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #595959;
    display: flex;
    align-items: center;
    justify-content: center;

    .material-icons {
        font-size: 18px;
    }

    &:hover {
        color: #1890ff;
        border-color: #1890ff;
    }

    &.active {
        background: #1890ff;
        border-color: #1890ff;
        color: white;
    }
}

.content-loader {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.loading-text {
    color: #8c8c8c;
    font-size: 14px;
    margin: 0;
}

.content-area {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f0f0f0;
    }

    &::-webkit-scrollbar-thumb {
        background: #d9d9d9;
        border-radius: 3px;

        &:hover {
            background: #bfbfbf;
        }
    }
}

.tasks-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
    padding: 0;
}

.task-grid-card {
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-4px);
        z-index: 10;
    }
}

.grid-card-inner {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid #e8e8e8;
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
        border-color: #1890ff;
    }
}

.task-grid-card:nth-child(4n+1) .grid-card-inner {
    .vue-avatar {
        border-color: white;
    }

    .avatar-more {
        border-color: white;
    }
}

.task-grid-card:nth-child(4n+2) .grid-card-inner {
    .vue-avatar {
        border-color: white;
    }

    .avatar-more {
        border-color: white;
    }
}

.task-grid-card:nth-child(4n+3) .grid-card-inner {
    .vue-avatar {
        border-color: white;
    }

    .avatar-more {
        border-color: white;
    }
}

.task-grid-card:nth-child(4n) .grid-card-inner {
    .vue-avatar {
        border-color: white;
    }

    .avatar-more {
        border-color: white;
    }
}

.card-image {
    width: 100%;
    height: 0;
    padding-bottom: 60%;
    position: relative;
    overflow: hidden;
    background: #f5f5f5;

    img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &.card-image-placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);

        .placeholder-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 48px;
            color: #bfbfbf;
        }
    }
}

.card-body {
    padding: 16px;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
}

.card-title {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    flex: 1;
    color: #262626;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.card-menu-btn {
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    color: #8c8c8c;
    padding: 0;

    &:hover {
        background: #f5f5f5;
        color: #262626;
    }

    .material-icons {
        font-size: 18px;
    }
}

.card-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    min-height: 24px;
}

.tag-chip {
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 500;
}

.tag-more {
    padding: 2px 6px;
    background: #f0f0f0;
    color: #8c8c8c;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 600;
}

.card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-top: auto;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;
}

.card-priority {
    svg {
        width: 18px;
        height: 18px;
    }
}

.card-assignees {
    display: flex;
    align-items: center;
    gap: 2px;

    .vue-avatar {
        margin-right: -8px;
        border: 2px solid white;
    }
}

.avatar-more {
    width: 22px;
    height: 22px;
    background: #1890ff;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 700;
    margin-left: 6px;
    border: 2px solid white;
}

.card-stats {
    display: flex;
    gap: 6px;
}

.stat-badge {
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: 11px;
    font-weight: 500;
    color: #8c8c8c;

    .material-icons {
        font-size: 15px;
    }
}

.tasks-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.task-list-card {
    cursor: pointer;
}

.list-card-inner {
    background: white;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    gap: 12px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #f0f0f0;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        border-color: #1890ff;
    }
}

.list-thumbnail {
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    border-radius: 6px;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.list-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.list-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
}

.list-title {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    color: #262626;
    flex: 1;
}

.priority-icon {
    flex-shrink: 0;

    svg {
        width: 18px;
        height: 18px;
    }
}

.list-description {
    font-size: 12px;
    color: #8c8c8c;
    line-height: 1.5;
    margin: 0;
}

.list-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.list-tag {
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 500;
}

.list-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.list-assignees {
    display: flex;
    align-items: center;
    gap: 2px;

    .vue-avatar {
        margin-right: -6px;
        border: 2px solid white;
    }
}

.list-meta {
    display: flex;
    gap: 8px;
}

.meta-badge {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 500;
    color: #8c8c8c;

    .material-icons {
        font-size: 14px;
    }
}

.list-menu-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    color: #8c8c8c;
    padding: 0;

    &:hover {
        background: #f5f5f5;
        color: #262626;
    }

    .material-icons {
        font-size: 18px;
    }
}

.empty-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
}

.empty-illustration {
    width: 160px;
    height: 160px;
    margin-bottom: 20px;
}

.empty-title {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
    margin: 0;
}

.custom-modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    background: white;
    border-top: 1px solid #e8e8e8;
}

.footer-info {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #595959;

    .material-icons {
        font-size: 16px;
        color: #1890ff;
    }

    strong {
        color: #262626;
        font-weight: 600;
    }
}

.task-actions-menu {
    .ant-menu-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        font-size: 13px;

        .material-icons {
            font-size: 16px;
            color: #8c8c8c;
        }

        &:hover {
            background: #f5f5f5;

            .material-icons {
                color: #1890ff;
            }
        }
    }
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: all 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter .custom-modal-container,
.modal-fade-leave-to .custom-modal-container {
    transform: scale(0.95);
    opacity: 0;
}

.fade-scale-enter-active,
.fade-scale-leave-active {
    transition: all 0.2s ease;
}

.fade-scale-enter,
.fade-scale-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
    opacity: 0;
    transform: translateY(10px);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

@media (max-width: 1400px) {
    .custom-modal-container {
        width: 75vw;
        min-width: 800px;
    }

    .tasks-grid {
        grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
        gap: 18px;
    }
}

@media (max-width: 1024px) {
    .custom-modal-container {
        width: 85vw;
        min-width: 700px;
    }

    .tasks-grid {
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
        gap: 16px;
    }
}

@media (max-width: 768px) {
    .custom-modal-container {
        width: 95vw;
        min-width: unset;
        max-height: 95vh;
    }

    .control-bar {
        gap: 8px;
    }

    .action-bar {
        flex-direction: column;
        align-items: stretch;
    }

    .date-filter {
        width: 100%;
    }

    .tasks-grid {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 12px;
    }

    .list-card-inner {
        flex-direction: column;
    }

    .list-thumbnail {
        width: 100%;
        height: 120px;
    }

    .custom-modal-footer {
        flex-direction: column;
        gap: 12px;
        align-items: center;
    }
}

@media (max-width: 480px) {
    .tab-btn {
        padding: 6px 12px;
        font-size: 12px;

        .material-icons {
            font-size: 16px;
        }

        .tab-text {
            display: none;
        }
    }

    .filter-label {
        display: none;
    }

    .tasks-grid {
        grid-template-columns: 1fr;
    }
}
</style>
